var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5207_18081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5207_18081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 31.5C5.675 31.5 4.96875 31.2063 4.38125 30.6188C3.79375 30.0312 3.5 29.325 3.5 28.5V7.5C3.5 6.675 3.79375 5.96875 4.38125 5.38125C4.96875 4.79375 5.675 4.5 6.5 4.5H30.5C31.325 4.5 32.0312 4.79375 32.6188 5.38125C33.2063 5.96875 33.5 6.675 33.5 7.5V28.5C33.5 29.325 33.2063 30.0312 32.6188 30.6188C32.0312 31.2063 31.325 31.5 30.5 31.5H6.5ZM8 25.5H15.5V22.5H8V25.5ZM22.325 22.5L29.75 15.075L27.6125 12.9375L22.325 18.2625L20.1875 16.125L18.0875 18.2625L22.325 22.5ZM8 19.5H15.5V16.5H8V19.5ZM8 13.5H15.5V10.5H8V13.5Z",
    fill: "#004EA8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterAttendance);
export default __webpack_public_path__ + "static/media/registerAttendance.bcca938eb5e56850887f51102042aa37.svg";
export { ForwardRef as ReactComponent };